import React from 'react';
import Phaser from 'phaser';
import { knock } from './effects';

class Logo extends Phaser.GameObjects.DOMElement {
  constructor(scene, x, y) {
    const div = document.createElement('div');
    div.style = 'width: 200px; text-align: center';

    if (window.__variables?.logo) {
      const figure = document.createElement('figure');
      figure.classList.add('image', 'is-64x64');
      figure.style = 'margin: 0 auto;';
      const image = document.createElement('img');
      image.src = window.__variables?.logo;

      figure.appendChild(image);
      div.appendChild(figure);
    }

    if (window.__variables?.host) {
      const caption = document.createElement('figcaption');
      caption.textContent = window.__variables?.host;
      div.appendChild(caption);
    }

    super(scene, x, y, div);

    scene.add.existing(this);
  }
}

export default class Door extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'door');

    this.setOrigin(0.5, 1);
    this.setScale(0.8);

    this.scene.add.existing(this);
    this.scene.add.arc(this.x - 1, this.y - 400, 105, 180, 360, false, 0x303764);
    this.scene.add.rectangle(this.x - 1, this.y - 400, 210, 16, 0x303764).setOrigin(0.5, 0);

    this.logo = new Logo(scene, this.x, this.y - 445);
  }

  open(fantasy = false) {
    this.setTexture(fantasy ? 'door_open_fantasy' : 'door_open');
  }

  knock() {
    knock.call(this.scene);
  }

  close() {
    this.setTexture('door');
  }
}
